import DrawerContent from 'components/drawers/DrawerContent'

const DialogBody = DrawerContent

export default DialogBody
